/**
 * Main Vite entry point for KWE Sitepackage
 *
 * This file serves as the primary entry point for Vite build process.
 * It imports all necessary styles and JavaScript modules for the
 * KWE Ehningen website.
 *
 * @author KWE Development Team
 * @version 1.0.0
 */

// Import Bootstrap JavaScript components
// Only import what we need for better tree-shaking and performance
import { Dropdown, Collapse, Modal, Tooltip, Popover, Carousel } from 'bootstrap';

// Import main SCSS file (includes Bootstrap CSS)
import './Scss/main.scss';



// Import Bootstrap Icons CSS
import 'bootstrap-icons/font/bootstrap-icons.css';

// Import our custom JavaScript modules
import './JavaScript/main.js';

// Make specific Bootstrap components available globally for debugging and external access
// This is useful for TYPO3 backend integration and third-party plugins
window.bootstrap = {
    Dropdown,
    Collapse,
    Modal,
    Tooltip,
    Popover,
    Carousel
};

// Log successful initialization
console.log('KWE Sitepackage Main.entry.js loaded successfully!');
console.log('Available Bootstrap components:', Object.keys(window.bootstrap));
